<script>
	export let value;
	export let onClick;
</script>

<input on:click={onClick} type="button" {value} />

<style>
	input {
		background-color: rgba(157, 138, 186);
		/* border-radius: 20px; */
		box-shadow: 10px 5px 5px rgb(192, 180, 212);
	}
	input:hover {
		background-color: rgb(192, 180, 212);
	}
	input:active {
		box-shadow: 0px 0px 0px rgb(192, 180, 212);
	}
</style>
